import React, {useState} from 'react';
import styled from '@emotion/styled';
import { Button } from '@mui/material';
import {  loadEmail, loadExcel, importExcel, sendEmail } from '../utils/connect';
import { useStateContext } from '../contexts/ContextProvider'

const Container = styled.div`
    display: flex;
    padding: 15px;
    width: 90%; 
    justify-content: flex-end;
`;

function EmailButtonGroup() {

    const { sendData, setSendData, setEmailPaneVisible, setToEditId, setLastMethod, setExcelList } = useStateContext();

    const processSendData = (data) => {
        return data
    }

    const handleImportClick = async () => {
        const inputElement = document.createElement('input');
        inputElement.type = 'file';
        inputElement.accept = ".xlsx, .xls";
        inputElement.onchange = async (e) => {
            const file = e.target.files[0];
            if (file) {
                console.log('filename',file.name);
                try {
                    const response = await importExcel(file);
                    async function fetchData() {
                        const responseData = await loadEmail();
                        const responseProcess = responseData.map(item => ({
                            id: item.attendee_id,
                            toSend: false,
                            name: item.full_name,
                            company: item.company_name,
                            email: item.email2,
                            business_matching_meeting: item.business_matching_meeting,
                            status: item.status === "No" ? "Not sent" : "Sent"
                        }));
                        setSendData(responseProcess);
                        const responseExcel = await loadExcel();
                        setExcelList(responseExcel.map(item => ({name:item.file_name, url:item.link, date: item.start_time})))
                    }
                    if(response !== "error") {
                        fetchData();
                        alert("File imported successfully");
                    }
                    else {
                        alert("File imported failed");
                    }
                    //const responseProcess = responseData["attendees"].map(item => ({
                    //    id: item.attendee_id,
                    //    toSend: false,
                    //    name: item.full_name,
                    //    company: item.company_name,
                    //    email: item.email2,
                    //    business_matching_meeting: item.business_matching_meeting,
                    //    status: item.status === "No" ? "Not sent" : "Sent"
                    //}));
                    //setSendData(sendData.concat(responseProcess))
                } catch (error) {
                    alert("Error importing file:", error);
                }
            }
        };
        inputElement.click();
    };

    const handleAddClick = () => {
        const existingIds = sendData.map(item => item.id);
        let newId;
        do {
            newId = Math.floor(Math.random() * 1000000); // 这里我们为新的ID设置了一个范围，例如0到999999。你可以根据需要修改这个范围。
        } while (existingIds.includes(newId));
        const id = newId;
        setSendData([{id:id, toSend:false, name:'', company: '', email:'', business_matching_meeting: '', status: 'Not sent'}, ...sendData])
        setToEditId(id)
        setEmailPaneVisible(true)
        setLastMethod("Add")
    }

    const handleSendEmail = async () => {
        const idList = sendData.filter(item => item.status !== 'Sent' && item.toSend === true).map(item => item.id);
        console.log('idList', idList);
        idList.forEach(async element => {
            const responseData = await sendEmail(element);
            if (responseData === "error") {
                setSendData(sendData.map((item) => (item.id === element ? {...item, status:"Error"} : item)))
            }
            else {
                setSendData(sendData.map((item) => (item.id === element ? {...item, status:"Sent"} : item)))
            }
            // console.log(responseData);
        });

        // await setSendData(processSendData(responseData))
    }

    return (
        <Container>
            <Button
                variant="contained"
                color="primary"
                style={{ margin: '0 8px' }}
                onClick={handleImportClick}
            >
                Import
            </Button>
            <Button
                variant="contained"
                color="primary"
                style={{ margin: '0 8px' }}
                onClick={handleAddClick}
            >
                Add
            </Button>
            <Button variant="contained" color="secondary" style={{ margin: '0 8px' }} onClick={handleSendEmail}>
                Send email
            </Button>
        </Container>
    );
}

export default EmailButtonGroup;
